import type { NavigateFunction } from "react-router-dom";

let navigateFunction: NavigateFunction | null = null;

export const setGlobalNavigate = (navigate: NavigateFunction) => {
  navigateFunction = navigate;
};

export const getGlobalNavigate = () => navigateFunction;
